<div *ngIf="orderReady">
    <!-- Header -->
    <div class="modal-header">
        <div class="title">
            <h2 class="modal-title">Informations du client</h2>
            <div class="info-client modal-title">
                <div>
                    <h4 style="text-transform: uppercase">{{this.clientInfos.firstName}} {{this.clientInfos.lastName}} <span>- {{this.clientInfos.id}}</span></h4>
                </div>
                <div>
                    <h6>
                        <span *ngIf="this.clientInfos.status === 'active'" style="color: #00cb4c;">Actif</span> 
                    </h6>
                </div>
            </div>
        </div>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <!-- Body -->
    <div class="modal-body d-flex flex-column ">
        <div class="info-client-details">
            <div class="d-flex flex-row">
                <div class="info-block">
                    <div>
                        <p><span class="text-bold">Anniversaire:</span> {{this.clientInfos.birthdate}}</p>
                        <p><span class="text-bold">Nationalité:</span> {{this.clientInfos.nationnality}}</p>
                    </div>
                </div>
            </div>
            <!-- Address -->
            <div class="d-flex flex-row">
                <!-- Delivery address -->
                <div class="d-flex flex-column flex-50">
                    <h5>Adresse de livraison</h5>
                    <div class="info-block">
                        <i class="fa fa-home" aria-hidden="true"></i>
                        <div>
                            <p>{{this.clientInfos.billing.address_1}}</p>
                            <p>{{this.clientInfos.billing.address_2}}</p>
                            <p>{{this.clientInfos.billing.postcode}} {{this.clientInfos.billing.city}} {{this.clientInfos.billing.country}}</p>
                        </div>
                    </div>
                </div>
                <!-- Billing address -->
                <div class="d-flex flex-column flex-50">
                    <h5>Adresse de facturation</h5>
                    <div class="info-block">
                        <i class="fa fa-home" aria-hidden="true"></i>
                        <div>
                            <p>{{this.clientInfos.shipping.address_1}}</p>
                            <p>{{this.clientInfos.shipping.address_2}}</p>
                            <p>{{this.clientInfos.shipping.postcode}} {{this.clientInfos.shipping.city}} {{this.clientInfos.shipping.country}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-row">
                <!-- Contact -->
                <div class="d-flex flex-column flex-50">
                    <h5>Contact</h5>
                    <div class="info-block">
                        <i class="fa fa-envelope-o" aria-hidden="true"></i>
                        <p>{{this.clientInfos.email}}</p>
                    </div>
                    <div class="info-block" *ngIf="this.clientInfos.phone">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <p>{{this.clientInfos.phone}}</p>
                    </div>
                </div>
                <!-- Info connection of account -->
                <div class="d-flex flex-column flex-50">
                    <h5>Compte</h5>
                    <p>Créé le <span class="text-bold">{{this.clientInfos.createdAt | date:'longDate'}}</span></p>
                    <p>Modifié le <span class="text-bold">{{this.clientInfos.updatedAt | date:'longDate'}}</span></p>
                    <p class="text-bold">{{this.clientInfos.nbConnects}} connexion<span *ngIf="this.clientInfos.nbConnects > 1">s</span></p>
                </div>
            </div>
            <!-- Orders -->
            <div class="d-flex flex-row">
                <div class="d-flex flex-row flex-33">
                    <p class="number">{{this.clientInfos.orderFinished}}</p>
                    <div class="d-flex flex-column">
                        <p class="number-info">Commande<span *ngIf="this.clientInfos.orderFinished > 1">s</span></p>
                        <p class="number-info">terminée<span *ngIf="this.clientInfos.orderFinished > 1">s</span></p>
                    </div>
                </div>
                <div class="d-flex flex-row flex-33">
                    <p class="number">{{this.clientInfos.orderProcessing}}</p>
                    <div class="d-flex flex-column">
                        <p class="number-info">Commande<span *ngIf="this.clientInfos.orderProcessing > 1">s</span></p>
                        <p class="number-info">en cours</p>
                    </div>
                </div>
                <div class="d-flex flex-row flex-33">
                    <p class="number">{{this.clientInfos.orderTotal}}</p>
                    <div class="d-flex flex-column">
                        <p class="number-info">Commande<span *ngIf="this.clientInfos.orderTotal > 1">s</span></p>
                        <p class="number-info">au totale<span *ngIf="this.clientInfos.orderTotal > 1">s</span></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
